class ContactApi {
    constructor(fetchService) {
        this.fetchService = fetchService;
    }
    contactEmployeeRequest(values) {
        return this.fetchService.post('/contact/employee', values);
    }
}
export default ContactApi;
